// @ts-check
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSessionJWT } from "utils";
import { getAccountInfo } from "./index.js";

export default function useGetAccountInfo() {
  const { sessionJWT } = useSessionJWT();

  const fetchAccountInfo = useCallback(async () => {
    const data = await getAccountInfo(sessionJWT);
    return data;
  }, [sessionJWT]);

  return useQuery({
    queryKey: ["accountInfo"],
    queryFn: fetchAccountInfo
  });
}
